import { useAuth } from "@/hooks/useAuth";
import { Navigate } from "react-router-dom";
import PendingApproval from "@/pages/PendingApproval";

interface ApprovalRouteProps {
  children: React.ReactNode;
}

const ApprovalRoute = ({ children }: ApprovalRouteProps) => {
  const { user, isApproved, loading } = useAuth()

  if (loading) {
    return <></>;
  }

  // Se l'utente non è autenticato, reindirizza al login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Se l'utente non è approvato, mostra la pagina di cortesia
  if (!isApproved) {
    return <PendingApproval />;
  }

  // Se l'utente è autenticato e approvato, mostra il contenuto protetto
  return <>{children}</>;
};

export default ApprovalRoute; 